export class User {
    Email: string;
    Cognito: Cognito;
    ApiKey: string;
    Preferences: Preferences;
    ApiServiceUrl: string;
    IoTEndpoint: string;
    RoleArn: string;
    FirstName: string;
    LastName: string;
}

export class Cognito {
    IdentityId: string;
    Token: string;
}

export class Preferences {
    AgreedToEula: boolean = true; // TODO: replace with default false when real preferences are availbale
}



// WEBPACK FOOTER //
// ./src/app/user/user.ts